/* index.js */ function _(require, module, exports) {
    var version_1 = require(104) /* ./version */;
    exports.version = version_1.version;
    var embed = require(105) /* ./embed */;
    exports.embed = embed;
    var embed_1 = require(105) /* ./embed */;
    exports.index = embed_1.index;
    var protocol = require(450) /* ./protocol */;
    exports.protocol = protocol;
    var _testing = require(451) /* ./testing */;
    exports._testing = _testing;
    var logging_1 = require(167) /* ./core/logging */;
    exports.logger = logging_1.logger;
    exports.set_log_level = logging_1.set_log_level;
    var settings_1 = require(128) /* ./core/settings */;
    exports.settings = settings_1.settings;
    var base_1 = require(108) /* ./base */;
    exports.Models = base_1.Models;
    var document_1 = require(106) /* ./document */;
    exports.documents = document_1.documents;
    var safely_1 = require(452) /* ./safely */;
    exports.safely = safely_1.safely;
}
